var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-4",attrs:{"height":"110px"}},[_c('v-col',[(_vm.productLogo)?_c('img',{staticClass:"logoStyle pr-5",attrs:{"src":_vm.getProductLogoImageUrl(),"alt":"logo"}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }